export const hapticFeedback = () => {
    // Vibrate if supported
    if ('vibrate' in navigator) {
    navigator.vibrate(50);
    }
};